// src/domains/gate.ts —— 06 U-24：未开通邮箱登录（Telegram 建号、无邮箱或无登录密码）的资金动作拦截与引导（2026-10-17）
// 判定口径与服务端一致：GET /profile → email_login_missing（null = 可用邮箱 + 密码登录）；资金端点服务端另以 1015 兜底
import { ApiError } from '../../../shared/src/api/client';
import type { Profile } from '../../../shared/src/api/types';

export type GateMissing = 'email' | 'password';

// 02 §13：1015 = 需先绑定邮箱并设置登录密码（data.reason = email_login_required，data.missing ∈ {email, password}）
export const GATE_CODE = 1015;
export const GATE_REASON = 'email_login_required';
// 引导弹层 modal.type（0453g 片）
export const GATE_MODAL = 'emailGate';

function asMissing(v: unknown): GateMissing | null {
  return v === 'email' || v === 'password' ? v : null;
}

// 当前会话是否受限；profile 未取到或旧服务端无该字段视同不受限（服务端仍以 1015 兜底）
export function gateMissing(p: Profile | null | undefined): GateMissing | null {
  return asMissing(p?.email_login_missing);
}

// 服务端 1015 → 缺哪一项；data.missing 缺失 / 非法时回落本地 profile 判定，再缺省按 email（引导第一步即绑定邮箱）
export function gateErrorMissing(e: unknown, p?: Profile | null): GateMissing | null {
  if (!(e instanceof ApiError) || e.code !== GATE_CODE) return null;
  return asMissing(e.data.missing) ?? gateMissing(p) ?? 'email';
}
